import { Headphones } from 'lucide-react';
import { useSelector } from 'react-redux';

import { Button } from '@design-system';
import { cn } from '@client/lib';
import { selectFeatureFlags, selectSession } from '@client/model/selectors';
import { SessionType } from '@shared/SessionType';

const WAG_AGENT_CALENDLY_URL = 'https://calendly.com/lily-waterlily/waterlily-new-user-walkthrough';

interface LicensedAgentCtaProps {
  variant?: 'default' | 'outline';
  size?: 'default' | 'sm' | 'lg';
  buttonLabel?: string;
  subtext?: string;
  className?: string;
  buttonClassName?: string;
  d2cOnly?: boolean;
}

export function LicensedAgentCta({
  variant = 'default',
  size = 'lg',
  buttonLabel = "Get free help from a licensed agent who doesn't earn commission",
  subtext,
  className,
  buttonClassName,
  d2cOnly = true,
}: LicensedAgentCtaProps) {
  const { sessionType } = useSelector(selectSession);
  const featureFlags = useSelector(selectFeatureFlags);
  const isD2C = sessionType === SessionType.client && !!featureFlags.d2cMode;

  if (d2cOnly && !isD2C) return null;

  return (
    <div className={cn('flex flex-col items-center gap-2 text-center', className)}>
      <Button
        size={size}
        variant={variant}
        className={cn(
          'w-sm h-max items-start text-wrap py-3 text-start sm:w-max sm:items-center sm:rounded-full sm:px-6 sm:text-center',
          buttonClassName,
        )}
        asChild
      >
        <a
          href={WAG_AGENT_CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Headphones className="size-5" />
          <span className="text-wrap sm:text-nowrap">{buttonLabel}</span>
        </a>
      </Button>
      {subtext && <p className="text-muted-foreground max-w-md text-xs">{subtext}</p>}
    </div>
  );
}
